const state = () => ({
    mp4PlayFlag:'',
    paddingBot:'100px',
    mobileFlag:false
})
const getters = {
    mp4PlayFlag : state => {
        return state.mp4PlayFlag
    },
    paddingBot: state => {
        return state.paddingBot
    },
    mobileFlag: state => {
        return state.mobileFlag
    }
}
const mutations = {
    SET_MP4_PLAY_FLAG: (state,currentPlay) => {
        state.mp4PlayFlag = currentPlay
    },
    SET_PADDINGBOT:(state,currentPadding) => {
        state.paddingBot = currentPadding
    },
    SET_MOBILEFLAG:(state,flag) => {
        state.mobileFlag = flag
    }
}

export default{
    namespaced:true,
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/module/home.js